import React, { useState, Suspense, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { getMerchantCodeWithPrefix } from "../../../tools/MyCCMerchantLinkGenerator";
import LocaleSelector from "../../common/components/LocaleSelector/LocaleSelector";
import LocaleSelectorModal from "../../common/components/LocaleSelector/LocaleSelectorModal";
import CCLogoColour from '../../common/media/cc_logo_color.svg';

const Navigation = ({
    selectedCurrency,
    onChangeCurrency,
    currentLang,
    localSelectedCurrency,
    setLocalSelectedCurrency,
    merchantCode,
}) => {
    const [isNavExpanded, setIsNavExpanded] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const isMobile = useMediaQuery({ query: "(max-width: 585px)" });

    const renderLoginButton = () => {
        return <a className="login-button" target="_blank" href={`${process.env.MY_CC_URL}/${getMerchantCodeWithPrefix(merchantCode)}?business`}>
            {!isMobile && <span className="color-black">Log In </span>}
            <img width="24px" height="24px" src="https://res.cloudinary.com/carbonclick/image/upload/v1655716908/Enterprise/Amadeus/login_icon_bzt8yw.svg" alt="login button" />
        </a>
    }

    return (<div className="navigation-container">
        <nav className="navigation p-3 mobile-p-0">
            <div className="nav-info d-flex align-center">
                <img className="amadeus-logo" src="https://res.cloudinary.com/carbonclick/image/upload/v1651055874/Enterprise/Amadeus/logo-amadeus_tkfvl7.svg" alt="amadeus logo" />
                {!isMobile && (
                    <div className="ml-3 d-flex align-baseline">
                        <p style={{ fontSize: 14 }} className="m-0">Powered by</p>
                        <img height={16} className="ml-2 amadeus-logo" src={CCLogoColour} alt="carbonclick logo" />
                    </div>
                )}
            </div>
            
            <div className="mobile-buttons">
                <button
                    className="hamburger"
                    onClick={() => setIsNavExpanded(!isNavExpanded)}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="black">
                        <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z" clipRule="evenodd" />
                    </svg>
                </button>

                {renderLoginButton()}
            </div>

            <div className={`navigation-menu ${isNavExpanded ? "expanded" : ""}`}>
                <ul onClick={() => setIsNavExpanded(false)} className="py-4">
                    {isMobile && (
                        <li className="h-center">
                            <LocaleSelector
                                selectedCurrency={selectedCurrency}
                                currentLang={currentLang}
                                setIsModalOpen={setIsModalOpen}
                            />
                        </li>
                    )}
                    <li><a href="#FlightCalculator">Offset</a></li>
                    <li><a href="#Projects">Projects</a></li>
                    <li><a href="#FAQ">FAQ</a></li>
                    {!isMobile && <>
                        <li className="h-center">
                            <LocaleSelector
                                selectedCurrency={selectedCurrency}
                                currentLang={currentLang}
                                setIsModalOpen={setIsModalOpen}
                            />
                        </li>
                        <li className="login-button-wrapper">{renderLoginButton()}</li>
                    </>}
                </ul>
            </div>
        </nav>

        <LocaleSelectorModal
            isModalOpen={isModalOpen}
            selectedCurrency={selectedCurrency}
            localSelectedCurrency={localSelectedCurrency}
            setLocalSelectedCurrency={setLocalSelectedCurrency}
            merchantCode={merchantCode}
            currentLang={currentLang}
            onChangeCurrency={onChangeCurrency}
            setIsModalOpen={setIsModalOpen}
        />

    </div>)
}

export default Navigation;